<script setup lang="ts">
import ChatHeader from './ChatHeader.vue'
import ChatProgress from './ChatProgress.vue'
import ChatFooter from './ChatFooter.vue'

defineProps<{
  showProgress?: boolean
}>()
</script>

<template>
  <!-- Desktop wrapper -->
  <div class="min-h-screen bg-gray-50 md:bg-gray-100">
    <!-- Chat container - full height, max width on desktop -->
    <div class="flex flex-col h-screen max-w-3xl mx-auto md:border-x md:border-gray-200 bg-gray-50">
      <!-- Header -->
      <ChatHeader />

      <!-- Progress -->
      <ChatProgress v-if="showProgress" />

      <!-- Main chat area -->
      <main class="flex-1 overflow-hidden">
        <slot />
      </main>

      <!-- Footer -->
      <ChatFooter />
    </div>
  </div>
</template>
